import { Chip, Skeleton, Stack, Tooltip, alpha, colors } from "@mui/material"
import numbro from "numbro"
import React from "react"

import usePoolShare from "../../hooks/use-pool-share"

interface Props {
  poolId: string
  tvl: number
  handlePoolShare: (poolId: string, userShares: number) => void
}

function PoolShare({ poolId, handlePoolShare, tvl }: Props) {
  const { data: poolShares, isLoading } = usePoolShare(poolId)

  React.useEffect(() => {
    if (!isLoading && poolShares) {
      handlePoolShare(poolId, poolShares.userShares)
    }
  }, [poolId, poolShares, handlePoolShare, isLoading])

  if (isLoading) {
    return <Skeleton variant="rounded" width={100} />
  }

  return (
    <Stack direction="row" spacing={1} justifyContent="end" alignItems="center">
      {poolShares?.lockedUserShares && poolShares.lockedUserShares > 0 ? (
        <Tooltip title="Locked Pool Share">
          <Chip
            variant="outlined"
            sx={() => ({
              borderRadius: 0,
              border: 0,
              background: alpha(colors.purple[500], 0.1),
              color: colors.purple[500],
              fontWeight: 700,
            })}
            label={
              numbro(poolShares.lockedUserShares).format({
                average: true,
                mantissa: 1,
              }) + "%"
            }
          />
        </Tooltip>
      ) : null}
      {poolShares?.userShares && poolShares.userShares > 0 ? (
        <Chip
          variant="outlined"
          sx={(theme) => ({
            borderRadius: 0,
            border: 0,
            background: alpha(theme.palette.accent.main, 0.1),
            color: theme.palette.accent.main,
            fontWeight: 700,
          })}
          label={
            numbro(poolShares.userShares).format({
              average: true,
              mantissa: 1,
            }) + "%"
          }
        />
      ) : null}
      <span>
        {numbro(tvl ?? 0).formatCurrency({
          average: true,
          mantissa: 1,
          currencySymbol: "$",
        })}
      </span>
    </Stack>
  )
}

export default React.memo(PoolShare)
